export const CLIENT_NAME_MAX_LENGTH = 255;
export const LENDER_NAME_MAX_LENGTH = 255;

export const LENDER_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export const CLIENT_STATUS_COLORS = {
  active: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  inactive: 'bg-slate-100 text-slate-500 border-slate-200',
  deprecated: 'bg-red-100 text-red-600 border-red-200',
} as const;

export const CLIENTS_PAGE_TITLE = 'Client & Lender Management';
export const CLIENTS_PAGE_SUBTITLE = 'Manage clients and their associated lenders for CSV imports.';
